import { AlertColor } from '@mui/material';
import { IAlertProps, IInlineAlertProps } from '@ankr.com/ui';
import { SnackbarProps } from '@mui/material/Snackbar';
import { Draft as WritableDraft } from 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type UnnecessaryMuiAlertProps =
  | 'children'
  | 'color'
  | 'classes'
  | 'key'
  | 'onClose'
  | 'ref'
  | 'role';

export interface INotificationProps
  extends SnackbarProps,
    Omit<IAlertProps, UnnecessaryMuiAlertProps>,
    Omit<IInlineAlertProps, UnnecessaryMuiAlertProps> {
  severity: AlertColor;
  isHTML?: boolean;
}

interface INotificationState {
  queue: INotificationProps[];
}

const initialState: INotificationState = {
  queue: [],
};

export const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    pushNotificationToTheQueue: (
      state,
      action: PayloadAction<INotificationProps>,
    ) => {
      const queue = state.queue.filter(item => item.key !== action.payload.key);

      state.queue = [
        ...queue,
        action.payload as WritableDraft<typeof action.payload>,
      ];
    },
    hideNotification: (state, action: PayloadAction<string>) => ({
      ...state,
      queue: state.queue.filter(item => item.key !== action.payload),
    }),
  },
});
